import { createAction, props } from '@ngrx/store';

export const LOAD_COUNTRYLIST = '[Country List] Load Country List';
export const LOAD_COUNTRYLIST_SUCCESS =
  '[Country List] Load Country List Success';
export const LOAD_COUNTRYLIST_FAILURE =
  '[Country List] Load Country List Failure';

export const loadCountryList = createAction(LOAD_COUNTRYLIST);

export const loadCountryListSuccess = createAction(
  LOAD_COUNTRYLIST_SUCCESS,
  props<{ countries: any[] }>()
);

export const loadCountryListFailure = createAction(
  LOAD_COUNTRYLIST_FAILURE,
  props<{ error: any }>()
);
